import React, { useState, useEffect } from "react";
import queryString from "query-string";
import PropTypes from "prop-types";
import axios from "axios";

const VipResultV3 = ({ location }) => {

  const [record, setRecord] = useState({});

  useEffect(() => {
    async function fetchExistingReport(token) {
      try {
        const result = await axios(`/api/vipv3/report_result/${token}`);
        //console.log("result", result.data.record);
        setRecord(result.data.record);
      } catch (error) {
        console.error(error);
      }
    }
    const search_values = queryString.parse(location.search);
    if (search_values.token) {
      fetchExistingReport(search_values.token);
    }
  }, [location.search]); 

  const version = record.report_type === '2'?'wire_report_v3':'wire_report_v2';

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6 mt-3">
          {record.report_status === '2' && (
          <div className="card border-success mb-3">
            <div className="card-header bg-success text-light">付款完成</div>
            <div className="card-body text-success">
              <h6 className="text-info mt-1 mb-1">
                下次可以透過
                <a
                  href={`/${version}/${record.game_id}?token=${record.token}`}
                >
                  此連結
                </a>
                來快速填寫訂單
              </h6>
              您的訂單內容如下:
              <div className="card-text">
                <table className="table table-hover">
                  <tbody>
                    <tr>
                      <th scope="row">訂單編號</th>
                      <td>{record.report_id}</td>
                    </tr>
                    <tr>
                      <th scope="row">Email</th>
                      <td>{record.email}</td>
                    </tr>
                    <tr>
                      <th scope="row">手機</th>
                      <td>{record.phone}</td>
                    </tr>
                    <tr>
                      <th scope="row">訂單金額</th>
                      <td>
                        {new Intl.NumberFormat("zh-TW", {
                          style: "currency",
                          currency: "TWD",
                        }).format(record.wire_amount)}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" colSpan="2">
                        <hr />
                      </th>
                    </tr>
                    <tr>
                      <th scope="row">遊戲</th>
                      <td>{record.game_name}</td>
                    </tr>
                    <tr>
                      <th scope="row">伺服器</th>
                      <td>{record.server_name}</td>
                    </tr>
                    <tr>
                      <th scope="row">角色ID</th>
                      <td>{record.role_id}</td>
                    </tr>
                    <tr>
                      <th scope="row">角色名稱</th>
                      <td>{record.char_name}</td>
                    </tr>

                    <tr>
                      <th scope="row">發票選項</th>
                      <td>{record.invoiceOption}</td>
                    </tr>
                    <tr>
                      <th scope="row">地址</th>
                      <td>{record.address}</td>
                    </tr>
                    <tr>
                      <th scope="row">購買方案</th>
                      <td>{record.title}</td>
                    </tr>
                    <tr>
                      <th scope="row">方案數量</th>
                      <td>{record.qty}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card-footer text-center">
              <small className="text-muted">
                / 服務時間：AM 10:00 ~ PM 17:00 /
              </small>
            </div>
          </div>)}
          {record.report_status === '8' && (
          <div className="card border-danger mb-3">
            <div className="card-header bg-danger text-light">付款失敗</div>
            <div className="card-body text-danger">
              <h6 className="text-info mt-1 mb-1">
                下次可以透過
                <a
                  href={`/${version}/${record.game_id}?token=${record.token}`}
                >
                  此連結
                </a>
                來快速填寫訂單
              </h6>
              您的訂單內容如下:
              <div className="card-text">
                <table className="table table-hover">
                  <tbody>
                    <tr>
                      <th scope="row">訂單編號</th>
                      <td>{record.report_id}</td>
                    </tr>
                    <tr>
                      <th scope="row">Email</th>
                      <td>{record.email}</td>
                    </tr>
                    <tr>
                      <th scope="row">手機</th>
                      <td>{record.phone}</td>
                    </tr>
                    <tr>
                      <th scope="row">訂單金額</th>
                      <td>
                        {new Intl.NumberFormat("zh-TW", {
                          style: "currency",
                          currency: "TWD",
                        }).format(record.wire_amount)}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">說明</th>
                      <td>{record.Message}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card-footer text-center">
              <small className="text-muted">
                / 服務時間：AM 10:00 ~ PM 17:00 /
              </small>
            </div>
          </div>)}
        </div>
        <div className="col-lg-3 mt-3"> </div>
      </div>
    </div>
  );
};

VipResultV3.propTypes = {
  record: PropTypes.object.isRequired,
};

export default VipResultV3;
